"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactComponents = require("@ui-propulsion/react-components");
var _classnames = _interopRequireDefault(require("classnames"));
require("./styles.scss");
var DollarAmountSection = function DollarAmountSection(_ref) {
  var label = _ref.label,
    name = _ref.name,
    isFieldDisabled = _ref.isFieldDisabled,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    type = _ref.type,
    step = _ref.step,
    errorMsg = _ref.errorMsg,
    value = _ref.value,
    boldText = _ref.boldText,
    isRequired = _ref.isRequired;
  var inputClasses = (0, _classnames.default)('dollar-amount__number', {
    'dollar-amount__number--disabled': isFieldDisabled,
    'dollar-amount__number--bold': boldText,
    'dollar-amount__number--error': errorMsg
  });
  var labelClasses = (0, _classnames.default)('dollar-amount__label', {
    'dollar-amount__label--bold': boldText
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    className: "dollar-amount__section",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: name,
    className: labelClasses
  }, label, isRequired && /*#__PURE__*/_react.default.createElement("i", {
    className: "required-indicator"
  }, "*"))), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    item: true,
    container: true,
    wrap: "nowrap",
    xs: 6
  }, /*#__PURE__*/_react.default.createElement("b", {
    className: "dollar-amount__symbol"
  }, "$"), /*#__PURE__*/_react.default.createElement("input", {
    type: type,
    step: step,
    "aria-label": label,
    inputMode: "decimal",
    name: name,
    disabled: isFieldDisabled,
    value: value,
    className: inputClasses,
    onChange: onChange,
    onBlur: onBlur,
    "aria-invalid": !!errorMsg,
    "data-test-id": name
  }))), /*#__PURE__*/_react.default.createElement(_reactComponents.Grid, {
    container: true,
    direction: "row",
    justifyContent: "flex-end"
  }, errorMsg && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: name,
    role: "alert",
    className: "input--error"
  }, errorMsg)));
};
DollarAmountSection.defaultProps = {
  boldText: false,
  isRequired: false,
  isFieldDisabled: false,
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  type: 'text',
  errorMsg: '',
  value: '',
  step: 10.0
};
DollarAmountSection.propTypes = {
  boldText: _propTypes.bool,
  label: _propTypes.string.isRequired,
  name: _propTypes.string.isRequired,
  onChange: _propTypes.func,
  onBlur: _propTypes.func,
  isFieldDisabled: _propTypes.bool,
  type: _propTypes.string,
  errorMsg: _propTypes.string,
  /* eslint-disable-next-line react/forbid-prop-types */
  value: _propTypes.any,
  step: _propTypes.number,
  isRequired: _propTypes.bool
};
var _default = exports.default = DollarAmountSection;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-refunds/lib/components/DollarAmount/styles.scss');